import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATES = ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming","Outside the US"];

export const NotifyForm = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !state) {
      toast.error("Please enter your email and select a state.");
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/notify`, { email, state });
      setDone(true);
      toast.success("You're on the list. We'll email you when your state's guidance launches.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p data-testid="notify-success-message" className="mt-6 text-sm text-[#C9A227] font-semibold">
        ✓ You're on the list for {state}. We'll be in touch.
      </p>
    );
  }

  return (
    <form onSubmit={submit} data-testid="notify-form" className="mt-6 space-y-3">
      <p className="text-sm font-semibold text-[#F7F6F2]">Get notified when your state's compliance guidance launches</p>
      <input
        type="email"
        data-testid="notify-email-input"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-sm text-[#F7F6F2] placeholder-[#F7F6F2]/40 focus:outline-none focus:border-[#C9A227] transition-colors duration-300"
      />
      <select
        data-testid="notify-state-select"
        aria-label="Select your state"
        value={state}
        onChange={(e) => setState(e.target.value)}
        className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-sm text-[#F7F6F2] focus:outline-none focus:border-[#C9A227] transition-colors duration-300 [&>option]:text-[#14213D]"
      >
        <option value="" disabled>Select your state</option>
        {STATES.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>
      <button
        type="submit"
        data-testid="notify-submit-btn"
        disabled={busy}
        className="w-full rounded-lg bg-[#C9A227] text-[#14213D] font-heading font-bold text-sm py-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md disabled:opacity-60"
      >
        {busy ? "Submitting…" : "Notify me"}
      </button>
    </form>
  );
};
